import UndoRedo, { PLUGIN_KEY } from './undoRedo';

export {
  PLUGIN_KEY,
  UndoRedo,
};
